import React, { useState, useEffect } from "react";
import styles from "./styles.module.scss";
import Authflow from "@features/Onboarding/ui/Authflow";

export type AuthStep =
  | "LOGIN"
  | "FORGOT_PASSWORD"
  | "CHECK_EMAIL"
  | "TWO_FACTOR";

const Onboarding: React.FC = () => {
  return (
    <div className={styles.container}>
      {/* Premium Dark Background */}
      <div className={styles.backgroundContainer}>
        <div className={styles.gradientBase}></div>
        <div className={styles.orbBlue}></div>
        <div className={styles.orbIndigo}></div>
        <div className={styles.gridPattern}></div>
      </div>

      <div className={styles.logoContainer}>
        <h1 className={styles.logoText}>cloutflow</h1>
      </div>

      <Authflow />

      <div className={styles.pageFooter}>
        <span>© cloutflow</span>
        <a className={styles.policyLink}>Privacy & terms</a>
      </div>
    </div>
  );
};

export default Onboarding;
